import {
    LOAD_CUSTOMER_INSIGHT_ORDER_SEARCH
} from "../../../actions/types";

const INITIAL_STATE = {
    content: [],
    totalPages: 0,
    totalElements: 0,
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case LOAD_CUSTOMER_INSIGHT_ORDER_SEARCH:
            return action.payload
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/restaurants/customerInsight/CustomerInsightOrderSearchReducer.js